/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_DescriptionInputs */

const cs_chat_attach_description = /** @type {(inputs: Chat_Attach_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledejte záznam v CRM nebo nahrajte soubor z počítače.`)
};

const en_chat_attach_description = /** @type {(inputs: Chat_Attach_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the CRM or upload a file from your computer.`)
};

/**
* | output |
* | --- |
* | "Search the CRM or upload a file from your computer." |
*
* @param {Chat_Attach_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_description = /** @type {((inputs?: Chat_Attach_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_description(inputs)
	return cs_chat_attach_description(inputs)
});